<template>
    <el-container class="task-trans-detail">
        <el-header>
            <Header></Header>
        </el-header>
        <el-main>
            <div class="title">
                <span><strong>任务交易详情</strong></span>
            </div>
            <el-row class="content">
                <el-col class="content-left">
                    <div class="content-top">
                        <div class="table-title">
                            <h3>当前持仓</h3>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th>交易所</th>
                                    <th>交易类型</th>
                                    <th>交易方向</th>
                                    <th>币种</th>
                                    <th>实时成本</th>
                                    <th>实时总数量</th>
                                    <th>最后交易时间</th>
                                    <th>更新时间</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in positionData.task_virtual_position" :key="index">
                                    <td v-for="(position_data, index1) in item" :key="index1">{{valueFormat(position_data, index1)}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="content-bottom">
                        <div class="table-title">
                            <h3>已平盈亏</h3>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th>交易类型</th>
                                    <th>交易币种</th>
                                    <th>平仓盈亏(USDT)</th>
                                    <th>平仓盈亏(币数)</th>
                                    <th>平仓时间</th>
                                    <th>更新时间</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in positionData.task_virtual_earnings" :key="index">
                                    <td v-for="(earnings_data, index1) in item" :key="index1">{{valueFormat(earnings_data, index1)}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </el-col>
                <el-col class="content-right">
                    <div class="chart-title">
                        <span><strong>任务收益曲线</strong></span>
                    </div>
                    <div class="mychart" ref="mychart"></div>
                </el-col>
            </el-row>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import Header from '@/components/header/Header.vue'
import Footer from '@/components/Footer/New-footer.vue'
import { mapState } from 'vuex'
import { get } from '@/api/index'
import { setTimeout } from 'timers';
 
export default {
    components: {
        Header,
       
    },
    data() {
        return {
            taskId: '',
            chartData: {},
            positionData: {},
        }
    },
    mounted() {
        this.taskId = this.$route.query.id;
        this.getTaskPosition();
        this.getTaskIncomeData();
    },
    computed: {
        ...mapState([
            'token'
        ])
    },
    methods: {

        // 获取任务持仓和已平的盈亏
        getTaskPosition() {
            var trade_type = this.$route.query.type;
            if (trade_type == 'task') {// 任务交易详情
                var url = this.$baseUrl + '/task/statistics/position/get';
                var param = {
                    'token': this.token,
                    'taskId': this.taskId
                };
            } else if (trade_type == 'ctask') {// 子任务交易详情
                var url = this.$baseUrl + '/task/children/statistics/position/get';
                var param = {
                    'token': this.token,
                    'childrenTaskId': this.taskId
                };
            }
            
            if (!this.taskId) return;
            get(url, param).then(resp => {
                if (resp.code == 200) {
                    this.positionData = resp.data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                }
            })
        },

        // 获取收益曲线数据
        getTaskIncomeData() {
            var trade_type = this.$route.query.type;
            if (trade_type == 'task') {// 任务交易详情
                var url = this.$baseUrl + '/task/statistics/realtime/earnings/get';
                var param = {
                    'token': this.token,
                    'taskId': this.taskId
                }
            } else if (trade_type == 'ctask') {// 子任务交易详情
                var url = this.$baseUrl + '/task/children/statistics/realtime/earnings/get';
                var param = {
                    'token': this.token,
                    'childrenTaskId': this.taskId
                };
            }

            
            if (!this.taskId) return;
            get(url, param).then(resp => {
                if (resp.code == 200) {
                    this.chartData = resp.data;
                    this.initEchart();
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100,
                        duration: '1000'
                    })
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 1000)
                }
            })
        },

        // 数据格式处理
        valueFormat(data, name) {
            if (name == 'price') {
                return data.toFixed(4);
            } else if (name == 'amount') {
                return data.toFixed(4);
            } else if (name == 'earnings_amount') {
                return data.toFixed(4);
            } else if (name == 'earnings') {
                return data.toFixed(4);
            }
            else {
                return data;
            }
        },

        // 绘制曲线
        initEchart() {
            var chartNode = this.$refs.mychart;
            var myChart = this.$echarts.init(chartNode);
            var x_data = this.chartData.dateTime;
            var y_data = this.chartData.earningsVal;

            var option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    },
                    position: [0, 0]
                },
                grid:[{
                    left: '3%',
                    top: '5%',
                    height: '75%'
                }],
                legend: {
                    data: ['任务收益'],
                    textStyle: {
                        color: '#A7A7A7'
                    }
                },
                dataZoom: [{
                    show: true,
                    realtime: true,
                    start: 0,
                    end: 100
                },
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                    height: 20
                }],
                xAxis: [
                    {
                        type : 'category',
                        boundaryGap : false,
                        data : x_data,
                        axisLabel: {
                            textStyle: {
                                fontSize: 10
                            },
                        },
                        axisTick: {
                            show: false,
                            interval: 2,
                            length: 10
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#A7A7A7'
                            }
                        },
                    }
                ],
                yAxis: [
                    {
                        type : 'value',
                        position: 'right',
                        axisLabel : {
                            formatter: '{value} ',
                            
                        },
                        splitNumber: 10,
                        splitLine: {
                            show: false,
                            lineStyle: {
                                type: 'dashed',
                                color: '#A7A7A7'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#A7A7A7'
                            }
                        },
                    }
                ],
                series: [
                    {
                        name: '任务收益',
                        type:'line',
                        symbol: 'circel',
                        symbolSize: 1,
                        smooth: true,
                        data: y_data,
                        lineStyle: {
                            color: 'rgba(34, 166, 148, 1)',
                            width: 1
                        },
                        areaStyle: {
                            normal: {
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(34, 166, 148, 1)'
                                },{
                                    offset: 1,
                                    color: 'rgba(34, 166, 148, 1)',
                                }], false),
                            }
                        },
                    },
                ]
            };

            myChart.setOption(option);

            window.onresize = () => {
                myChart.resize();
            }
        },
    }
}
</script>

<style lang="scss">
    .task-trans-detail{
        table{
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            thead{
                background-color: #262829;
                tr{
                    th{
                        padding: 5px 3px;
                    }
                }
            }
            tbody{
                background-color: #262829;
                tr{
                    // border-bottom: 1px solid #A7A7A7;
                    td{
                        // border: 1px solid #403c3c;
                        padding: 5px 0;
                    }
                }
                tr:hover{
                    background-color: #1e1e1e;
                }
            }
        }
        .table-title{
            background-color: #1e1e1e;
            padding: 10px;
            h3{
                text-align: center;
            }
        }
        .el-main{
            // padding: 0 10px;
            min-height: 650px;
            margin-top: 15px;
            color: #A7A7A7;
            .title{
                padding: 10px;
                margin-bottom: 5px;
                background-color: #262829;
            }
            .content{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                background-color: #2A2D2E;
                padding: 10px;
                .content-left{
                    height: 800px;
                    flex: 1;
                    .content-top{
                        height: 400px;   
                        margin-bottom: 5px;
                        background-color: #262829;
                        margin-bottom: 10px;
                    }
                    .content-bottom{
                        height: 390px;   
                        background-color: #262829;
                    }
                }
                .content-right{
                    height: 450px;
                    background-color: #262829;
                    margin-left: 5px;
                    flex: 1;
                    .chart-title{
                        padding: 10px;
                        background-color: #1e1e1e;
                    }
                    .mychart{
                        width: 100%;
                        height: 400px;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 420px) {
        .task-trans-detail{
            .el-main{
                .content{
                    padding: 5px;
                }
            }
        }
    }
</style>
